<script>
import { authComputed } from '@state/helpers'
import Notes from '@components/tabs/notes.vue'
import Translate from '@components/tabs/aws-translate/aws-translate.vue'
import Bio from '@components/tabs/bio.vue'
import Accounts from '@components/tabs/accounts.vue'
import Sims from '@components/tabs/sims.vue'
import SMS from '@components/tabs/sms.vue'

export default {
  components: { SMS, Notes, Bio, Sims, Accounts, Translate },
  computed: {
    ...authComputed,
  },
  methods: {},
}
</script>

<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="phone" />
        SMS
      </span>
      <SMS />
    </a-tab-pane>

    <a-tab-pane v-if="$route.fullPath.includes('figment-research')" key="2">
      <span slot="tab">
        <a-icon type="profile" />
        Bio
      </span>
      <Bio />
    </a-tab-pane>

    <a-tab-pane v-if="$route.fullPath.includes('figment-research')" key="3">
      <span slot="tab">
        <a-icon type="contacts" />
        Accounts
      </span>
      <Accounts />
    </a-tab-pane>

    <a-tab-pane v-if="$route.fullPath.includes('figment-research')" key="4">
      <span slot="tab">
        <a-icon type="block" />
        SIM
      </span>
      <Sims />
    </a-tab-pane>

    <a-tab-pane key="5">
      <span slot="tab">
        <a-icon type="edit" />
        Notes
      </span>
      <Notes />
    </a-tab-pane>

    <a-tab-pane key="6">
      <span slot="tab">
        <a-icon type="zhihu" />
        Translate
      </span>
      <Translate />
    </a-tab-pane>
  </a-tabs>
</template>

<style lang="scss" module>
@import '@design';
</style>
